import { Input } from "@chakra-ui/react"
import React from "react"

const DateCustomInput = (
  inputProps: React.HTMLProps<HTMLInputElement>,
  ref: React.Ref<HTMLInputElement>,
): React.ReactElement => {
  const { value, onClick, onChange, placeholder } = inputProps
  return (
    <Input
      ref={ref}
      bgColor="white"
      value={value}
      onClick={onClick}
      onChange={onChange}
      placeholder={placeholder ?? "Pick a date"}
    />
  )
}

export default DateCustomInput
